"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskPassport = void 0;
const uuid_1 = require("uuid");
class TaskPassport {
    constructor() {
        this.taskId = (0, uuid_1.v4)();
    }
}
exports.TaskPassport = TaskPassport;
//# sourceMappingURL=task-passport.js.map